import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-12 md:py-24 bg-neutral-950 border-t border-neutral-800 text-center" data-id="element-18">
      <div className="container mx-auto px-4" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-20">
          <h2 className="font-bebas text-5xl md:text-7xl text-white uppercase tracking-wide mb-4 md:mb-6" data-id="element-21">
            La IA ya funciona.
            <br data-id="element-22" />
            <span className="text-brand-500" data-id="element-23">
              La diferencia está en cómo la usás.
            </span>
          </h2>
          <p className="text-xl text-neutral-400 mb-6 md:mb-10" data-id="element-24">
            Prompt Wear es el sistema para hacerlo bien.
          </p>
          <div className="max-w-md mx-auto" data-id="element-25">
            <Button href="https://checkout.promptwearr.shop/cart/44479124242567:1" pulse data-id="element-26">
              👉 Acceder ahora
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}